import { runInAction } from "mobx";
import { Link, useLocation } from "react-router-dom";
import { observer } from "mobx-react-lite";

import AppStore from "AppStore";

import { getMarketCrumbs, SERVICES_CRUMB_TITLE } from "utils/breadcrumbs";

import "./Breadcrumbs.scss";

const Breadcrumbs = observer(({ shouldShowBreadcrumbs = false }) => {
  const { pathname } = useLocation();

  const hiddenPaths = [
    "/",
    "/projects",
    "/referral",
    "/settings",
    "/payment-form",
    "/signin",
    "/signup",
    "/restore",
    "/reset",
    "/blog"
  ];

  if (hiddenPaths.includes(pathname) || pathname.includes('/invite/'))
    return null;

  // endpoints и их названия на страницах
  const breadcrumbMap = {
    blog: "Блог",
    "nakrutka-pf-osnovnye-metody": "Что такое накрутка поведенческих факторов: основные методы",
    "nuzhno-li-krutit-pf-dlya-google": "Нужно ли крутить ПФ для Google?",
    "priznaki-neestestvennogo-trafika": "Как понять, что на сайт идёт неестественный трафик",
    "zashchita-ot-nakrutki-konkurentami": "Как защититься, если конкуренты накручивают ваш сайт",
    "testirovshchiki-ili-tehnicheskie-agenty": "Тестировщики и технические агенты: что выбрать",
    "kak-popast-v-moyu-volnu": "Как попасть в «Мою волну»: что влияет на рекомендации",
    "presave-yandex-music-kak-nastroit": "Пресейв: как настроить, сколько нужно и когда запускать",
    "kalendar-reliza": "Календарь релиза: что и за сколько дней успеть",
    "nakrutka-proslushivaniy-pravila-distributorov": "Что бывает за накрутку прослушиваний: правила дистрибьюторов",
  };

  let crumbs = [];

  const marketInfo = AppStore.findMarketStoreAndCalculatorByPath(pathname);
  if (marketInfo) {
    const { i, j } = marketInfo;
    runInAction(() => {
      AppStore.selectMarketStoreAndCalculatorByIndexes(i, j);
    });
    const calculator = AppStore.currentMarketStore.currentCalculator;
    const { mode } = calculator;

    // Тот же источник, что у BreadcrumbList JSON-LD в Market.jsx.
    crumbs = getMarketCrumbs(mode, pathname);
  } else {
    let currentPath = "";
    const pathSegments = pathname.split("/").filter((segment) => segment !== "");
    
    crumbs = pathSegments.map((segment) => {
      currentPath += `/${segment}`;
      return {
        title: breadcrumbMap[segment] || segment,
        path: currentPath
      };
    });
  }

  const handleServicesClick = (e) => {
    e.preventDefault();
    AppStore.setIsDropdownLinksOpen(true);
  };

  return (
    <div className={`breadcrumbs ${shouldShowBreadcrumbs ? "other-margin": ""}`}>
      <div className="breadcrumbs__container">
        {crumbs.map((crumb, index) => (
          <div className="crumb" key={index}>
            {index === crumbs.length - 1 ? (
              <span>{crumb.title}</span>
            ) : crumb.title === SERVICES_CRUMB_TITLE ? (
              <Link to="/" onClick={handleServicesClick}>{crumb.title}</Link>
            ) : (
              <Link to={crumb.path}>{crumb.title}</Link>
            )}
          </div>
        ))}
      </div>
    </div>
  );
});

export default Breadcrumbs;